import { render, staticRenderFns } from "./CustomTranslateDialog.vue?vue&type=template&id=404ac02a&scoped=true"
import script from "./CustomTranslateDialog.vue?vue&type=script&lang=js"
export * from "./CustomTranslateDialog.vue?vue&type=script&lang=js"
import style0 from "./CustomTranslateDialog.vue?vue&type=style&index=0&id=404ac02a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404ac02a",
  null
  
)

export default component.exports